import { jsx as _jsx } from "react/jsx-runtime";
import { validateReviewers } from '~/business-logic/draftLogic';
import { AddAdditionalRecipients } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/AddAdditionalRecipients/AddAdditionalRecipients';
import { allReviewersComplete } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/Recipients/utils/isCompleteReviewer';
import { draftClientId } from '../draftClient.utils';
import { ClientAdditionalRecipientsModalContent } from './ClientAdditionalRecipientsModalContent/ClientAdditionalRecipientsModalContent';
const MODAL_WIDTH = '800px';
export const recipientsCellAvailability = (param)=>{
    let { draft, contact, clientAware, isDisabled, disabledTooltip, draftCellsTexts } = param;
    if (isDisabled) {
        return {
            isDisabled,
            disabledTooltip
        };
    }
    if (!clientAware) {
        return {
            isDisabled: false,
            disabledTooltip: undefined
        };
    }
    if (draft.isSample()) {
        return {
            isDisabled: true,
            disabledTooltip: draftCellsTexts.additionalRecipientsSampleDisabled()
        };
    }
    if (draftClientId(draft, contact) == null) {
        return {
            isDisabled: true,
            disabledTooltip: draftCellsTexts.additionalRecipientsRequiresClient()
        };
    }
    return {
        isDisabled: false,
        disabledTooltip: undefined
    };
};
export const renderAdditionalRecipientsModal = (param)=>{
    let { draft, setDraft, wasSubmitted, title, primaryContact } = param;
    return {
        title,
        testId: 'edit-additional-recipients-modal',
        onSubmit: (defaultBehavior)=>{
            defaultBehavior();
        },
        content: /*#__PURE__*/ _jsx(AddAdditionalRecipients, {
            initialState: draft.reviewers(),
            showReviewerErrors: wasSubmitted || undefined,
            primaryContact: primaryContact,
            onChange: (newReviewers)=>setDraft(draft.setReviewers(newReviewers))
        })
    };
};
const renderClientAdditionalRecipientsModal = (param)=>{
    let { draft, setDraft, wasSubmitted, title, testId } = param;
    return {
        title,
        testId,
        onSubmit: (defaultBehavior)=>void defaultBehavior(),
        content: /*#__PURE__*/ _jsx(ClientAdditionalRecipientsModalContent, {
            draft: draft,
            setDraft: setDraft,
            showReviewerErrors: wasSubmitted
        })
    };
};
export const additionalRecipientsModalOptions = (param)=>{
    let { title, primaryContact, validationTexts } = param;
    return {
        width: MODAL_WIDTH,
        shouldSubmit: (editedDraft)=>Promise.resolve(validateReviewers(editedDraft.reviewers(), primaryContact, validationTexts)),
        renderContent: (param)=>{
            let { wasSubmitted, draft, setDraft } = param;
            return renderAdditionalRecipientsModal({
                draft,
                setDraft,
                wasSubmitted,
                title,
                primaryContact
            });
        }
    };
};
export const clientAdditionalRecipientsModalOptions = (param)=>{
    let { title, testId, primaryContact, validationTexts } = param;
    return {
        width: MODAL_WIDTH,
        shouldSubmit: (editedDraft)=>Promise.resolve(allReviewersComplete(editedDraft.reviewers()) && validateReviewers(editedDraft.reviewers(), primaryContact, validationTexts)),
        renderContent: (param)=>{
            let { wasSubmitted, draft, setDraft } = param;
            return renderClientAdditionalRecipientsModal({
                draft,
                setDraft,
                wasSubmitted,
                title,
                testId
            });
        }
    };
};
